/* global storefrontScreenReaderText */

/**
 * navigation.js
 *
 * Handles toggling the navigation menu for small screens.
 * Also adds a focus class to parent li's for accessibility.
 */
( function () {
	document.addEventListener( 'DOMContentLoaded', function () {
		const container = document.getElementById( 'nav-main' );
		if ( ! container ) {
			return;
		}

		const button = container.querySelector( 'button' );

		if ( ! button ) {
			return;
		}

		const menu = container.querySelector( 'ul' );

		// Hide menu toggle button if menu is empty and return early.
		if ( ! menu ) {
			button.style.display = 'none';
			return;
		}

		button.setAttribute( 'aria-expanded', 'false' );
		menu.setAttribute( 'aria-expanded', 'false' );
		menu.classList.add( 'nav-menu' );

		button.addEventListener( 'click', function () {
			container.classList.toggle( 'toggled' );
			const expanded = container.classList.contains( 'toggled' )
				? 'true'
				: 'false';
			button.setAttribute( 'aria-expanded', expanded );
			menu.setAttribute( 'aria-expanded', expanded );
		} );

		// Add dropdown toggle that displays child menu items.
		const menus = document.querySelectorAll('.nav-menu, .site-footer__menu');

		menus.forEach(function(menu) {
			const anchors = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');
			anchors.forEach(function(anchor) {
				if (document.documentElement.clientWidth <= 1280) {
					createButton(anchor);
				}
			});
		});

		// Add focus class to parents of sub-menu anchors.
		[].forEach.call(
			document.querySelectorAll(
				'.site-header .menu-item > a, .site-header .page_item > a, .site-header-cart a'
			),
			function ( anchor ) {
				anchor.addEventListener( 'focus', function () {
					// Remove focus class from other sub-menus previously open.
					const elems = document.querySelectorAll( '.focus' );

					[].forEach.call( elems, function ( el ) {
						if ( ! el.contains( anchor ) ) {
							el.classList.remove( 'focus' );

							// Remove blocked class, if it exists.
							if ( el.firstChild && el.firstChild.classList ) {
								el.firstChild.classList.remove( 'blocked' );
							}
						}
					} );

					// Add focus class.
					const li = anchor.parentNode;

					li.classList.add( 'focus' );
				} );
			}
		);

		// Ensure the dropdowns close when user taps outside the site header
		[].forEach.call(
			document.querySelectorAll( 'body #page > :not( .site-header )' ),
			function ( element ) {
				element.addEventListener( 'click', function () {
					[].forEach.call(
						document.querySelectorAll( '.focus, .blocked' ),
						function ( el ) {
							el.classList.remove( 'focus' );
							el.classList.remove( 'blocked' );
						}
					);
				} );
			}
		);

		// Add an identifying class to dropdowns when on a touch device
		// This is required to switch the dropdown hiding method from a negative `left` value to `display: none`.
		if (
			( 'ontouchstart' in window || window.navigator.maxTouchPoints ) &&
			window.innerWidth > 767
		) {
			[].forEach.call(
				document.querySelectorAll(
					'.site-header ul ul, .site-header-cart .widget_shopping_cart'
				),
				function ( element ) {
					element.classList.add( 'sub-menu--is-touch-device' );
				}
			);

			// Add blocked class to links that open sub-menus, and prevent from navigating away on first touch.
			let acceptClick = false;

			[].forEach.call(
				document.querySelectorAll(
					'.site-header .menu-item > a, .site-header .page_item > a, .site-header-cart a'
				),
				function ( anchor ) {
					anchor.addEventListener( 'click', function ( event ) {
						if (
							anchor.classList.contains( 'blocked' ) &&
							acceptClick === false
						) {
							event.preventDefault();
						}

						acceptClick = false;
					} );

					anchor.addEventListener( 'pointerup', function ( event ) {
						if (
							anchor.classList.contains( 'blocked' ) ||
							event.pointerType === 'mouse'
						) {
							acceptClick = true;
						} else if (
							( anchor.className === 'cart-contents' &&
								anchor.parentNode.nextElementSibling &&
								anchor.parentNode.nextElementSibling.textContent.trim() !==
									'' ) ||
							anchor.nextElementSibling
						) {
							anchor.classList.add( 'blocked' );
						} else {
							acceptClick = true;
						}
					} );

					
				}
			);
		}

		// Close menu when clicking outside
		document.addEventListener('click', function(event) {
			if (!container.contains(event.target)) {
				container.classList.remove('toggled');
				button.setAttribute('aria-expanded', 'false');
				menu.setAttribute('aria-expanded', 'false');
			}
		});
	} );
	
} )();

//Gestion button
function createButton ( anchor ) {
	// Add dropdown toggle that displays child menu items
	const btn = document.createElement( 'button' );
	btn.setAttribute( 'aria-expanded', 'false' );
	btn.classList.add( 'dropdown-toggle' );
	btn.appendChild(
		document.createTextNode(
			"+"
		)
	);

	const btnSpan = document.createElement( 'span' );
	btnSpan.classList.add( 'screen-reader-text' );
	btnSpan.appendChild(
		document.createTextNode(
			myfScreenReaderText.expand
		)
	);

	btn.appendChild( btnSpan );

	anchor.parentNode.insertBefore( btn, anchor.nextSibling );

	// Récupérer le lien de l'événement pour l'appliquer sur un nouveau bouton
	// pour un fonctionnement mobile simple au click
	const linkText = anchor.textContent || anchor.innerText;
	if (anchor.href && !anchor.href.endsWith('#') && anchor.href !== window.location.href) {

		const newLink = document.createElement('a');
		newLink.textContent = `Voir ${linkText}`;
		newLink.href = anchor.href;
		newLink.classList.add('menu-item__link-mobile');
		newLink.addEventListener('click', function() {
			window.location.href = anchor.href;
		});
		
		const container = btn.parentNode.querySelector('.mgmenu__inner');
		const ulContainer = btn.parentNode.querySelector('ul');
		
		// console.log(ulContainer);
		if (container) {
			container.insertBefore(newLink, container.firstChild);
		} else if (ulContainer) {
			const newListItem = document.createElement('li');
			newListItem.appendChild(newLink);
			ulContainer.insertBefore(newListItem, ulContainer.firstChild);
		}
	}

	// Set the active submenu dropdown toggle button initial state
	if (
		anchor.parentNode.classList.contains(
			'current-menu-ancestor'
		)
	) {
		btn.setAttribute( 'aria-expanded', 'true' );
		btn.classList.add( 'toggled-on' );
		btn.nextElementSibling.classList.add( 'toggled-on' );
	}

	// Add event listener
	// btn.addEventListener( 'click', handleButtonClick );
	
	btn.addEventListener('click', function(event) {
		handleButtonClick(event, btn, btnSpan);
	});
	// anchor.addEventListener( 'click', handleButtonClick );	
	anchor.addEventListener('click', function(event) {
		handleButtonClick(event, btn, btnSpan);
	});			
}

function handleButtonClick(event, btn, btnSpan){
	event.preventDefault(); // Empêcher le comportement par défaut
	
	// Apply animation directly in JavaScript
	const isToggledOn = btn.classList.toggle('toggled-on');
	if (isToggledOn) {
		btn.style.transition = 'transform 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000)';
		btn.style.transform = 'rotate(45deg)';
	} else {
		btn.style.transition = 'transform 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000)';
		btn.style.transform = 'rotate(0deg)';
	}

	// Remove text inside span
	while ( btnSpan.firstChild ) {
		btnSpan.removeChild( btnSpan.firstChild );
	}

	const expanded = btn.classList.contains( 'toggled-on' );

	btn.setAttribute( 'aria-expanded', expanded );
	btnSpan.appendChild(
		document.createTextNode(
			expanded
				? myfScreenReaderText.collapse
				: myfScreenReaderText.expand
		)
	);
	btn.nextElementSibling.classList.toggle( 'toggled-on' );
}


// STICKY HEADER  
// Get the header
const header = document.getElementById("masthead");

const sticky = header.offsetTop;

// Fonction pour ajouter/enlever la classe "sticky" en fonction du scroll
function sticky_header() {
	const topbar = document.querySelector('.site-topbar'); // Sélectionnez l'élément topbar

	if (window.scrollY > sticky) {
		document.body.style.paddingTop = `${header.offsetHeight}px`; // Compense la hauteur du header dans le flux de la page
		header.classList.add("sticky");

		if (topbar) {
			topbar.style.display = 'none'; // Cachez la topbar
		}
	} else {
		header.classList.remove("sticky");
		document.body.style.paddingTop = '0'; // Remet à zéro quand le header n'est plus sticky

		if (topbar) {
			topbar.style.display = ''; // Affichez la topbar
		}
	}
}

// Ajoute un écouteur d'événement pour détecter le défilement
window.addEventListener("scroll", sticky_header);